import { Injectable } from '@angular/core';
import {ModalController, ToastController} from "@ionic/angular/standalone";
import {BehaviorSubject, Subject} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  loadedUrl$ = new BehaviorSubject<string>(this.getLoadedUrl());
  loadedUrl: string = '';
  scannerValue$ = new Subject<string>();
  nativeFileReceived$ = new Subject<File>();
  isMobilePlatform = false;
  appVersion = '';
  refreshCalendar$ = new Subject<void>();

  constructor() {

  }

  setLoadedUrl(url: string) {
    this.loadedUrl = url;
    this.loadedUrl$.next(this.getLoadedUrl());
  }

  getLoadedUrl(): string {
    return this.loadedUrl;
  }


  nextOnRefreshCalendar() {
    this.refreshCalendar$.next();
  }

}
